import * as React from 'react';
import { GetEventData, GetRailProps } from 'react-compound-slider';

export interface RailProps {
    activeHandleID: string;
    getEventData: GetEventData;
    getRailProps: GetRailProps;
}

export class Rail extends React.PureComponent<RailProps> {
    public render() {
        const getRailProps = this.props.getRailProps;

        return <div className="pf-range-rail" {...getRailProps()}/>;
    }
}
